export default __webpack_public_path__ + "static/media/bg5.09cfb983.jpg";